import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StripeConnectionStatusWrapper = styled.div`
  padding: ${Spacing.S6} ${Spacing.S12};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.RFull};
`
